import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { u as B } from "../../chunks/use-sitecore-context.C7g4vcbm.js";
import { D as L } from "../../chunks/divider.C0gR8ZZB.js";
import { S as N, a as S, M as D, B as M } from "../../chunks/Subscription.CgP0M3T8.js";
import { c as m } from "../../chunks/clsx.OuTLNxxd.js";
const b = (t) => {
  var n, c;
  const a = (t == null ? void 0 : t.callToAction) && (t == null ? void 0 : t.callToAction.value.href) !== "", e = m("row align-items-center", {
    "justify-content-center ": !a
  }), i = m({
    "col-lg-6 mt-5 mt-lg-0": a
  });
  return /* @__PURE__ */ f("div", { className: m(e, "neu-bg-support-60 neu-text-plain-0 p-5"), children: [
    /* @__PURE__ */ o("div", { className: a ? "col-12 col-lg-6" : "d-none", children: /* @__PURE__ */ o(N, { ...t.fields }) }),
    /* @__PURE__ */ o("div", { className: i, children: /* @__PURE__ */ o(
      S,
      {
        socialTitle: (n = t == null ? void 0 : t.fields) == null ? void 0 : n.socialTitle,
        socialLinkList: (c = t == null ? void 0 : t.fields) == null ? void 0 : c.socialLinkList
      }
    ) })
  ] });
}, q = ({ fields: t, rendering: a }) => {
  var u, r, h, T, g, v, x, k, A, C;
  const {
    sitecoreContext: {
      siteAttributes: { isMarket: e }
    }
  } = B();
  if (!t)
    return null;
  const { site: i, location: n, campaign: c } = t, s = e ? i : n;
  if (!s || !i || !c)
    return null;
  const l = c && ((r = (u = c.footer.complianceLinks) == null ? void 0 : u.value) == null ? void 0 : r.length) !== 0 ? c.footer : s.footer;
  return /* @__PURE__ */ f("div", { className: "d-flex flex-column", "data-test-id": a == null ? void 0 : a.componentName, children: [
    /* @__PURE__ */ o(
      b,
      {
        fields: c.footer,
        ctaTitle: (g = (T = (h = t == null ? void 0 : t.campaign) == null ? void 0 : h.footer) == null ? void 0 : T.ctaTitle) == null ? void 0 : g.value,
        ctaDescription: (k = (x = (v = t == null ? void 0 : t.campaign) == null ? void 0 : v.footer) == null ? void 0 : x.ctaDescription) == null ? void 0 : k.value,
        callToAction: (C = (A = t == null ? void 0 : t.campaign) == null ? void 0 : A.footer) == null ? void 0 : C.callToAction
      }
    ),
    /* @__PURE__ */ o(D, { fields: t }),
    /* @__PURE__ */ o(L, {}),
    /* @__PURE__ */ o(M, { fields: l, copyright: l == null ? void 0 : l.copyright })
  ] });
};
export {
  q as CampaignFooter
};
